// src/components/AddEditProductionSteps.jsx
import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Select, MenuItem, FormControl, InputLabel, Typography, Grid, Chip} from "@mui/material";
import { grey } from "@mui/material/colors";
import axios from "axios";
import env from "react-dotenv";

const AddEditProductionSteps = ({ onClose, onSave, editData, onExpandDrawer }) => {
    const [showNewProductForm, setShowNewProductForm] = useState(false);
    const [showNewDepartmentForm, setShowNewDepartmentForm] = useState(false);
    const [showNewProcessForm, setShowNewProcessForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [existingSteps, setExistingSteps] = useState([]); // State to hold existing steps
    const [stepOrderError, setStepOrderError] = useState(""); // State for step order error

    const [formData, setFormData] = useState({
        product_id: "",
        dept_id: "",
        dept_ids: [], // Multiple departments selected (ids)
        machine_id: "",
        process_id: "",
        step_name: "",
        step_order: "",
        step_duration: "",
        step_status: "",
        dept_name: "",
        // New fields for the new product form
        new_product_name: "",
        full_name: "",
        // unit_cost: "",
        descrip: "",
        // New fields for the new section form
        new_section_name: "",
        new_section_remark: "",
        // New fields for the new process form
        new_process_name: "",
        new_process_remark: ""
    });

    const [options, setOptions] = useState({
        products: [],
        departments: [],
        processes: []
    });

    // useEffect(() => {
    //     fetchDropdownData();
    //     if (editData) {
    //         setFormData(editData);
    //     }
    // }, [editData]);

    useEffect(() => {
        fetchDropdownData();
        if (editData) {
            // convert existing single dept_id or dept_ids to array if needed
            setFormData(prev => ({
                ...prev,
                ...editData,
                dept_ids: Array.isArray(editData.dept_ids) ? editData.dept_ids : (editData.dept_id ? [editData.dept_id] : [])
            }));
        }
    }, [editData]);

    const fetchDropdownData = async () => {
        try {
            const [products, departments, processes] = await Promise.all([
                axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`),
                axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/department`),
                axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/proccess`)
            ]);
            setOptions({
                products: products.data,
                departments: departments.data,
                processes: processes.data
            });
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    // Handle the multi-department selection change
    const handleDeptChange = (event) => {
        let {
            target: { value },
        } = event;
        setFormData({
            ...formData,
            dept_ids: typeof value === 'string' ? value.split(',') : value,
        });
    };

    const fetchExistingSteps = async (productId) => {
       try {
           const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-steps/steps/product/${productId}`);
        //    console.log("Fetched Existing Steps:", response.data); // Log the response
           return response.data; // Assuming the response contains an array of steps
       } catch (error) {
           console.error("Error fetching existing steps:", error);
           return [];
       }
   };

//    console.log("Existing Steps:", existingSteps);
//    console.log("Current Step Order:", formData.step_order);

    const handleChange = async (e, field, idField, optionsArray = [], optionKey = "") => {
        const { value } = e.target;

        if (field === "product_id") {
        // Fetch existing steps for the selected product
        const existingSteps = await fetchExistingSteps(value);
        setExistingSteps(existingSteps);
        }
    
        if (value === "other") {
            // Show the appropriate new form based on the field
            if (field === "product_id") {
                setShowNewProductForm(true);
            } else if (field === "dept_id") {
                setShowNewDepartmentForm(true);
            } else if (field === "process_id") {
                setShowNewProcessForm(true);
            } 

            onExpandDrawer();
            // Reset the form data for the selected field
            setFormData(prevState => ({
                ...prevState,
                [field]: "",
                [idField]: ""
            }));
        } else {
            // Hide the new forms
            setShowNewProductForm(false);
            setShowNewDepartmentForm(false);
            setShowNewProcessForm(false);
    
            // If optionsArray is provided, find the selected item
            if (optionsArray.length > 0 && optionKey) {
                const selectedItem = optionsArray.find(item => item[optionKey] === value) || {};
                setFormData(prevState => ({
                    ...prevState,
                    [field]: selectedItem[optionKey] || "",
                    [idField]: selectedItem.id || ""
                }));
    
                // Update step_name based on selected process_id
                if (field === "process_id") {
                    const selectedProcess = options.processes.find(process => process.id === selectedItem.id);
                    if (selectedProcess) {
                        setFormData(prevState => ({
                            ...prevState,
                            step_name: selectedProcess.process_name // Set step_name to process_name
                        }));
                    }
                }
    
                // Update dept_name based on selected dept_id
                if (field === "dept_id") {
                    const selectedDept = options.departments.find(department => department.id === selectedItem.id);
                    if (selectedDept) {
                        setFormData(prevState => ({
                            ...prevState,
                            dept_name: selectedDept.dept_name // Set dept_name to department name
                        }));
                    }
                }
            } else {
                // Update the form data for the selected field
                setFormData(prevState => ({
                    ...prevState,
                    [field]: value
                }));
            }
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     onSave(formData);
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Log existing steps to understand their structure
        // console.log("Existing Steps:", existingSteps);
        
        // Extract existing step orders correctly
        const existingStepOrders = existingSteps[0].map(step => step.step_order);
        const currentStepOrder = Number(formData.step_order); // Convert to number
        const isEditing = editData && editData.step_order === currentStepOrder;
        // console.log("Form Data:", formData);
        // console.log("Existing Step Orders:", existingStepOrders);
        // console.log("Is Editing:", isEditing);
        // Check for unique step order
        if (!isEditing && existingStepOrders.includes(currentStepOrder)) {
            setStepOrderError("This step order already created for the selected product please enter unique step order.");
            return; // Prevent form submission
        } else {
            setStepOrderError(""); // Clear the error if valid
        }

        try {
            // Prepare array of selected department objects with dept_id and dept_name
            const selectedDepartments = options.departments.filter(d => formData.dept_ids.includes(d.id));
            // Get selected product name from product_id
            const selectedProduct = options.products.find(p => p.id === formData.product_id);
            
        // Build data object to send
        const dataToSave = {
            product_id: formData.product_id,
            dept_id: formData.dept_id,
            process_id: formData.process_id,
            step_name: formData.step_name,
            step_order: formData.step_order,
            dept_name: formData.dept_name,
            machine_id: formData.machine_id,
            step_duration: formData.step_duration,
            step_status: formData.step_status,
            product_name: selectedProduct ? selectedProduct.product_name : "",
            departments: formData.dept_ids.map(deptId => {
            const dept = options.departments.find(d => d.id === deptId);
            return {
                dept_id: deptId,
                dept_name: dept ? dept.dept_name : "" // Get the name of the department for dependencies
            };
          })
        };
            onSave(dataToSave);
        } catch (error) {
            console.error("Error preparing data to save:", error);
        }
    };

    const handleNewProductSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`, {
                product_name: formData.new_product_name,
                full_name: formData.full_name,
                // unit_cost: formData.unit_cost,
                descrip: formData.descrip
            });
            resetNewProductForm();
            fetchDropdownData();
        } catch (error) {
            console.error("Error adding new product:", error);
            setErrorMessage("Failed to add new product. Please try again.");
        }
    };

    const handleNewDepartmentSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/department`, {
                dept_name: formData.new_section_name,
                remark: formData.new_section_remark
            });
            resetNewDepartmentForm();
            fetchDropdownData();
        } catch (error) {
            console.error("Error adding new section:", error);
            setErrorMessage("Failed to add new section. Please try again.");
        }
    };

    const handleNewProcessSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/proccess`, {
                process_name: formData.new_process_name,
                remark: formData.new_process_remark
            });
            resetNewProcessForm();
            fetchDropdownData();
        } catch (error) {
            console.error("Error adding new process:", error);
            setErrorMessage("Failed to add new process. Please try again.");
        }
    };

    const resetNewProductForm = () => {
        setFormData(prevState => ({
            ...prevState,
            new_product_name: "",
            full_name: "",
            // unit_cost: "",
            descrip: ""
        }));
        setShowNewProductForm(false);
    };

    const resetNewDepartmentForm = () => {
        setFormData(prevState => ({
            ...prevState,
            new_section_name: "",
            new_section_remark: ""
        }));
        setShowNewDepartmentForm(false);
    };

    const resetNewProcessForm = () => {
        setFormData(prevState => ({
            ...prevState,
            new_process_name: "",
            new_process_remark: ""
        }));
        setShowNewProcessForm(false);
    };

    return (
        <>
            {/* Header */}
            <Box sx={{ mb: 3, borderBottom: `2px solid ${grey[300]}`, paddingBottom: 1, bgcolor: grey[200], p: 2, textAlign: "center" }}>
                <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "center", mb: 1, mt: 1 }}>
                    {editData ? "Edit Production Step" : "Add Production Step"}
                </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
            {/* Main Form Box */}
                <Box sx={{ ml: 2, mt: 2, mr: 2, mb: 0, p: 2, border: "1px solid #ccc", borderRadius: 2, flex: 1 }}>

                    {/* <Box sx={{ display: "flex", gap: 2, marginTop: 1, marginBottom: 1 }}> */}
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormControl fullWidth margin="dense" size="small">
                                    <InputLabel>Product</InputLabel>
                                    <Select
                                        name="product_id"
                                        value={formData.product_id}
                                        onChange={(e) => handleChange(e, "product_id", "product_id", options.products, "id")}
                                    >
                                        <MenuItem 
                                            value="other" 
                                            sx={{ 
                                                color: 'blue', 
                                                // backgroundColor: 'lightgrey', 
                                                '&:hover': {
                                                    backgroundColor: 'blue', // Change to a darker shade of blue or any color you prefer
                                                    color: 'white' // Change text color on hover
                                                }
                                            }} 
                                        >
                                            Add New Product
                                        </MenuItem>
                                        {options.products.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.product_name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth margin="dense" size="small">
                                    <InputLabel>Section</InputLabel>
                                    <Select
                                        name="dept_id"
                                        value={formData.dept_id}
                                        onChange={(e) => handleChange(e, "dept_id", "dept_id", options.departments, "id")}
                                    >
                                        <MenuItem 
                                            value="other" 
                                            sx={{ 
                                                color: 'blue', 
                                                // backgroundColor: 'lightgrey', 
                                                '&:hover': {
                                                    backgroundColor: 'blue', // Change to a darker shade of blue or any color you prefer
                                                    color: 'white' // Change text color on hover
                                                }
                                            }} 
                                        >
                                            Add New Section
                                        </MenuItem>
                                        {options.departments.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.dept_name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth margin="dense" size="small">
                                    <InputLabel>Process/Step</InputLabel>
                                    <Select
                                        name="process_id"
                                        value={formData.process_id}
                                        onChange={(e) => handleChange(e, "process_id", "process_id", options.processes, "id")}
                                    >
                                        <MenuItem 
                                            value="other" 
                                            sx={{ 
                                                color: 'blue', 
                                                // backgroundColor: 'lightgrey', 
                                                '&:hover': {
                                                    backgroundColor: 'blue', // Change to a darker shade of blue or any color you prefer
                                                    color: 'white' // Change text color on hover
                                                }
                                            }} 
                                        >
                                            Add New Process
                                        </MenuItem>
                                        {options.processes.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.process_name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Step Order"
                                    name="step_order"
                                    type="number"
                                    value={formData.step_order}
                                    onChange={(e) => handleChange(e, "step_order")} // Use handleChange
                                    error={!!stepOrderError} // Set error prop based on the error state
                                    helperText={stepOrderError} // Display the error message
                                />
                            </Grid>

                            <Grid item xs={6}>
                            <FormControl fullWidth margin="dense" size="small">
                                <InputLabel>Department Dependancy</InputLabel>
                                <Select
                                    multiple
                                    value={formData.dept_ids}
                                    onChange={handleDeptChange}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map(value => {
                                                const dept = options.departments.find(d => d.id === value);
                                                return <Chip key={value} label={dept ? dept.dept_name : value} />
                                            })}
                                        </Box>
                                    )}
                                >
                                    {options.departments.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.dept_name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        </Grid>
                        {/* Buttons */}
                        <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 3, display: "flex", justifyContent: "space-between" }}>
                            <Button variant="contained" size="small" color="success" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} type="submit">
                                Save
                            </Button>
                            <Button variant="outlined" size="small" color="error" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} onClick={onClose}>
                                Cancel
                            </Button>
                        </Box>
                    </form>
                {/* </Box> */}
            </Box>

            {/* New Product Form */}
            {showNewProductForm && (
                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, mt: 2, mr: 2, flex: 1 }}>
                    <Box sx={{ mb: 3, borderBottom: `2px solid ${grey[300]}`, bgcolor: grey[200], p: 1, textAlign: "center" }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "center"}}>
                            New Product Details
                        </Typography>
                    </Box>
                    <form onSubmit={handleNewProductSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Enter Product"
                                    name="new_product_name"
                                    value={formData.new_product_name}
                                    onChange={(e) => setFormData({ ...formData, new_product_name: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Full Name"
                                    name="full_name"
                                    value={formData.full_name}
                                    onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                                />
                            </Grid>
                            {/* <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Unit Cost"
                                    name="unit_cost"
                                    value={formData.unit_cost}
                                    onChange={(e) => setFormData({ ...formData, unit_cost: e.target.value })}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Description"
                                    name="descrip"
                                    value={formData.descrip}
                                    onChange={(e) => setFormData({ ...formData, descrip: e.target.value })}
                                    multiline
                                    rows={3}
                                />
                            </Grid>
                        </Grid>

                        {/* Buttons for the new product form */}
                        <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 3, display: "flex", justifyContent: "space-between" }}>
                            <Button variant="contained" size="small" color="success" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} type="submit">
                                Save
                            </Button>
                            <Button variant="outlined" size="small" color="error" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} onClick={() => setShowNewProductForm(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </form>
                </Box>
            )}

            {/* New Department Form */}
            {showNewDepartmentForm && (
                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, mt: 2, mr: 2, flex: 1 }}>
                    <Box sx={{ mb: 3, borderBottom: `2px solid ${grey[300]}`, bgcolor: grey[200], p: 1, textAlign: "center" }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "center"}}>
                            New Section Details
                        </Typography>
                    </Box>
                    <form onSubmit={handleNewDepartmentSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Department Name"
                                    name="new_section_name"
                                    value={formData.new_section_name}
                                    onChange={(e) => setFormData({ ...formData, new_section_name: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Remark"
                                    name="new_section_remark"
                                    value={formData.new_section_remark}
                                    onChange={(e) => setFormData({ ...formData, new_section_remark: e.target.value })}
                                />
                            </Grid>
                        </Grid>
                        {/* Buttons for the new section form */}
                        <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 3, display: "flex", justifyContent: "space-between" }}>
                            <Button variant="contained" size="small" color="success" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} type="submit">
                                Save
                            </Button>
                            <Button variant="outlined" size="small" color="error" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} onClick={() => setShowNewDepartmentForm(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </form>
                </Box>
            )}
            {/* New Process Form */}
            {showNewProcessForm && (
                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, mt: 2, mr: 2, flex: 1 }}>
                    <Box sx={{ mb: 3, borderBottom: `2px solid ${grey[300]}`, bgcolor: grey[200], p: 1, textAlign: "center" }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "center"}}>
                            New Process Details
                        </Typography>
                    </Box>
                    <form onSubmit={handleNewProcessSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Process Name"
                                    name="new_process_name"
                                    value={formData.new_process_name}
                                    onChange={(e) => setFormData({ ...formData, new_process_name: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    label="Remark"
                                    name="new_process_remark"
                                    value={formData.new_process_remark}
                                    onChange={(e) => setFormData({ ...formData, new_process_remark: e.target.value })}
                                />
                            </Grid>
                        </Grid>

                        {/* Buttons for the new process form */}
                        <Box sx={{ mt: 3, borderTop: `2px solid ${grey[300]}`, paddingTop: 3, display: "flex", justifyContent : "space-between" }}>
                            <Button variant="contained" size="small" color="success" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} type="submit">
                                Save
                            </Button>
                            <Button variant="outlined" size="small" color="error" sx={{ fontSize: "0.65rem", padding: "3px 6px" }} onClick={() => setShowNewProcessForm(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </form>
                </Box>
            )}
        </Box>
        </>
    );
};

export default AddEditProductionSteps;